// extracted by mini-css-extract-plugin
var _1 = "FavoritesButton-GwNgN";
var _2 = "Heart-NVrP5";
var _3 = "HeartBackground-ckm5P";
var _4 = "HeartFilled-hbjwx";
var _5 = "scaleIn-JLHJM";
export { _1 as "FavoritesButton", _2 as "Heart", _3 as "HeartBackground", _4 as "HeartFilled", _5 as "scaleIn" }
